<template>
  <div class="row justify-content-center">
    <div class="col-md-5" >
      <form @submit.prevent="onFormSubmit">
        <h2 style="margin-bottom: 20px;">Login</h2>
        <div class="form-group">
          <input type="email" required class="form-control" placeholder="email" v-model="email" autofocus="false">
        </div>
        <div class="form-group">
          <input @keypress.enter.prevent="onFormSubmit" type="password" required class="form-control" placeholder="password" v-model="password">
        </div>
        <p class="error">{{ error.message }}</p>
        <div class="form-group">
          <button class="btn btn-primary btn-block">ACCEDI</button>
        </div>
        <p>Password dimenticata? 
          <b-button variant="outline-success"  @focus="resetPwd" @click="resetPwd" class="linkable" autofocus="true">RESET Password</b-button>
          </p>
      </form>
      <b-modal id="resetPwdModal" ref="resetPwdModal" centered hide-footer title="Reimposta PASSWORD">
        <template>
          <ResetPwd />
        </template>
        <!-- <div class="d-block text-center">
          <h5>Inserisci l'indirizzo email di registrazione, riceverai un’email con le istruzioni per resettare la password.
          </h5>
        </div>
        <b-input-group prepend="@ email" class="mt-3">
          <b-form-input type="email" required v-model="email"></b-form-input>
          <b-input-group-append>
            <b-button variant="outline-success" @click="sendPwdResEmail(email)">INVIA</b-button>
          </b-input-group-append>
        </b-input-group>
        <p class="error" variant="error" style="margin: 20px;">{{ error.message }}</p> -->
      </b-modal>
    </div>
  </div>
</template>

<script>
  import { db, auth } from '../firebase/config.js';
  import { mapGetters, mapMutations } from 'vuex';
  import ResetPwd from './users/ResetPwd.vue';

  export default {
    data() {
      return {
        email: '',
        password: '',
        error: {
          value: null,
          message: ''
        }
      }
    },
    computed: {
      ...mapGetters({
        // map `this.user` to `this.$store.getters.user`
        user: "user",
        // map `this.sel_**` to `this.$store.getters._**`
        sel_user: "_user",
        sel_card: "_card"
      }),
    },
    components: {
      ResetPwd
    },
    methods: {
      onFormSubmit(event) {
        event.preventDefault()
        // Set login persistence to SESSION
        auth.setPersistence('session')
        .then(function() {
          console.log('LOGIN persistence set to SESSION')
        })
        .catch((err) => {
          console.log('LOGIN persistence SET failed: ', err);
        })
        // Sign-in
        auth.signInWithEmailAndPassword(this.email , this.password)
        .then(userCredential => {
          console.log(userCredential.user.displayName, userCredential.user.uid, "LOGIN OK!");
          if(!userCredential.user) {
            throw new Error('Invalid Credential');
          }
          // Get user token
          auth.currentUser.getIdTokenResult()
          .then((idTokenResult) => {
            // Get customClaims if they are defined
            if (!idTokenResult.claims) {
              throw new Error('Claims undefined')
            }
            const claims = {
              isAdmin: idTokenResult.claims.isAdmin,
              orgId: idTokenResult.claims.orgId,
              role: idTokenResult.claims.role
            } 
            console.log('auth.token after login: ', idTokenResult)
            // get store / company name
            let storeId = 'undefined!'
            let storeName = 'undefined!'
            let storeDefaults = {}
            let storeSelfApp = {}

            const stores = []
            db.collection('stores')
            .where('orgId', '==', claims.orgId)
            .get()
            .then((snapShot) => {
              snapShot.forEach((doc) => {
                if(!doc.exists) throw new Error('No Stores for OrgId:', claims.orgId)
                console.log('store', doc.id, doc.data())
                stores.push({
                  id: doc.id,
                  ...doc.data()
                })
              })
              if(stores.length == 1) {
                storeId = stores[0].id
                storeName = stores[0].name + ' (' + stores[0].defaults.province + ')'
                storeDefaults = stores[0].defaults
                storeSelfApp = stores[0].selfApp
              } else { 
                alert('ERROR: multiple stores for same orgId NOT still managed!')
                throw new Error('Multiple stores NOT managed for orgId', claims.orgId)
              }
              //check abilitazioni SELF WeApp DogMotics
              //active=true -> SELF App enabled
              if(!storeSelfApp.active) {
                alert('Il tuo Store NON è abilitato per la DogMotics WebApp!')
                throw new Error('Store not enabled on DogMotics WebApp', storeId)
              }
              //eCom=true -> modalità eCommerce ON
              if(storeSelfApp.eCom) {
                //test=true -> modalità eCommerce solo in modalità di TEST su userId specifico
                if(storeSelfApp.testEcom &&
                  storeSelfApp.testUserId != userCredential.user.uid) {
                  alert('DogMotics WebApp eCom in modalità test su User: ' +  storeSelfApp.testName)
                  /*throw new Error('DogMotics WebApp eCom in test mode on userId: ', storeSelfApp.testUserId)*/
                  storeSelfApp.eCom = false
                }
              }
              const user = {
                loggedIn: true,
                claims,
                ...userCredential.user,
                storeId: storeId,
                storeName: storeName,
                storeDefaults: storeDefaults,
                storeSelfApp: storeSelfApp
              }
              this.set_user(user);
              
              console.log('LoggedIn / User / claims: ', this.user.loggedIn, this.user, this.user.claims)
              this.error.message = '';
              this.$router.push({ name: 'user_profile' })
            })
            .catch((err) => {
              console.log(err);
              throw new Error(err.message + 'Organization not found')
            })
          })
          .catch((err) => {
            console.log(err);
            throw new Error(err.message + 'Token not found');
          })
        })
        .catch((err) => {
          console.log(err);
          this.error.message = err.message;
        })
      },
      /*onFormSubmit(event) {
        event.preventDefault()
        // Set login persistence to SESSION
        auth.setPersistence('session')
        .then(function() {
          console.log('LOGIN persistence set to SESSION')
        })
        .catch((err) => {
          console.log('LOGIN persistence SET failed: ', err);
        })
        // Sign-in
        auth.signInWithEmailAndPassword(this.email , this.password)
        .then(userCredential => {
          console.log(userCredential.user.displayName, userCredential.user.uid, "LOGIN OK!");
          if(!userCredential.user) {
            throw new Error('Invalid Credential');
          }

          auth.onAuthStateChanged(user => {
            store.dispatch("fetchUser", user);
          });
          // Get user token
          auth.currentUser.getIdTokenResult()
          .then((idTokenResult) => {
            // Get customClaims if they are defined
            if (!idTokenResult.claims) {
              throw new Error('Claims undefined')
            }

            const claims = {
              isAdmin: idTokenResult.claims.isAdmin,
              orgId: idTokenResult.claims.orgId,
              role: idTokenResult.claims.role
            }
            //console.log('claims', claims)
            this.set_user_claims(claims);
            console.log('user_claims', this.user.claims)

            // get store / company name
            let storeId = 'undefined!'
            let storeName = 'undefined!'
            let storeDefaults = {}

            const stores = []
            db.collection('stores')
            .where('orgId', '==', claims.orgId)
            .get()
            .then((snapShot) => {
              snapShot.forEach((doc) => {
                if(!doc.exists) throw new Error('No Stores for OrgId:', claims.orgId)
                console.log('store', doc.id, doc.data())
                stores.push({
                  id: doc.id,
                  ...doc.data()
                })
              })
              if(stores.length == 1) {
                storeId = stores[0].id
                storeName = stores[0].name + ' (' + stores[0].defaults.province + ')'
                storeDefaults = stores[0].defaults
              } else { 
                alert('ERROR: multiple stores for same orgId NOT still managed!')
                throw new Error('Multiple stores NOT managed for orgId', claims.orgId)
              }
              const user = {
                ...userCredential.user,
                //...claims,
                storeId: storeId,
                storeName: storeName,
                storeDefaults: storeDefaults
              }
              this.set_user(user);
              
              console.log('LoggedIn / User / claims: ', this.user.loggedIn, this.user.data, this.user.claims)
              
              this.set_sel_user({...user, ...claims})
              console.log('Selected User: ', this.sel_user)
              
              this.error.message = '';
              
              //this.$router.push({ name: 'user_profile' })
              //START
              db.collection('users')
              .doc(this.user.data.uid)
              .collection('privacy')
              .get()
              .then((querySnapshot) => {
                if(querySnapshot.empty) {
                  this.$router.push({ name: 'edit_privacy' })
                  //Per accedere al servizio occorre prima registrare i consensi privacy
                }
                else {
                  this.$router.push({ name: 'user_profile' })
                }
              })
              //END
            })
            .catch((err) => {
              console.log(err);
              throw new Error(err.message + 'Organization not found')
            })
          })
          .catch((err) => {
            console.log(err);
            throw new Error(err.message + 'Token not found');
          })
        })
        .catch((err) => {
          console.log(err);
          this.error.message = err.message;
        })
      },*/
      resetPwd() {
        this.error.message = ''
        this.$refs['resetPwdModal'].show()
      },
      hideModal() {
        this.focusTrigger = true //autofocus moved to email input field
        this.$refs['resetPwdModal'].hide()
        this.$router.push({name:'user_profile'})
      },
      ...mapMutations({
        set_user: 'SET_USER',
        set_user_claims: 'SET_USER_CLAIMS',
      })
    }
  };
</script>

<style>
  .form-group {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-right: 10px !important;
    align-items: center
  }
  label {
    width: 30%;
    color: #555;
  }
  input {
    width: 70%;
    color: #111;
    border: 0px;
    border-bottom: 1px;
    border-bottom-color: #555;
  }
  .btn-primary {
    margin: 20px;
    margin-bottom: 30px;
    border-radius: 20px;
    background: #bad300;
    border: #aac100;
    width: 40%;
    align-items: center
  }
  .btn-primary:hover {
    background: #777;
  }
  .btn-primary:a {
    background: #777;
  }
  .error {
    font-size: small;
    color: $#f81e47;
  }
</style>